import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { CommonModule } from '@angular/common';
import { DataHelper } from '@helpers/data.helper';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { WebWorkerService } from '@app/modules/workers/web-worker.service';
import { DataService } from '@services/data.service';
import { SharedModule } from '@app/modules/shared.module';
import { TicketScannerComponent } from './ticket.scanner.component';
import { RouterModule, Routes } from '@angular/router';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ScannerTicketComponent } from './scanner-ticket.component';
import { UtilsModule } from '@app/modules/utils.module';

const routes: Routes = [
  {
    path: 'scan',
    component: TicketScannerComponent,
  },
  {
    path: 'slipDetail/:slipid',
    component: ScannerTicketComponent,
  },
];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, ZXingScannerModule, RouterModule.forChild(routes), UtilsModule],
  declarations: [TicketScannerComponent, ScannerTicketComponent],
  exports: [],
  providers: [ApiService, UiHelper, UserHelper, LocalizationService, SignalrServiceLegacy, ScrollDispatcher, DataHelper, DataService, RouteGuardHelper, WebWorkerService],
})
export class ScannerModule {}
